import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDeepLinkDetection = () => {
  const location = useLocation();
  const [deepLinkType, setDeepLinkType] = useState(null);
  const [deepLinkData, setDeepLinkData] = useState(null);

  useEffect(() => {
    const path = location.pathname;
    
    // Reset
    setDeepLinkType(null);
    setDeepLinkData(null);

    // Trip Plans normali
    if (path.startsWith('/trip/') || path.startsWith('/trip-plan/') || path.startsWith('/itinerary/')) {
      const tripId = path.split('/')[2];
      if (tripId) {
        setDeepLinkType('trip');
        setDeepLinkData({ tripId, path });
      }
    }

    // Trip Plans condivisi
    else if (path.startsWith('/share/trip/') || path.startsWith('/share/itinerary/')) {
      const tripId = path.split('/')[3]; // /share/trip/{id}
      if (tripId) {
        setDeepLinkType('sharedTrip');
        setDeepLinkData({ tripId, path, isShared: true });
      }
    }

    // Profili utente
    else if (path.startsWith('/profile/') || path.startsWith('/user/')) {
      const nickname = path.split('/')[2];
      if (nickname) {
        setDeepLinkType('profile');
        setDeepLinkData({ nickname, path });
      }
    }

    // App Events
    else if (path.startsWith('/app-event/')) {
      const eventId = path.split('/')[2];
      if (eventId) {
        setDeepLinkType('appEvent');
        setDeepLinkData({ eventId, path });
      }
    }

    // Chatroom
    else if (path.startsWith('/chatroom/')) {
      const roomId = path.split('/')[2];
      if (roomId) {
        setDeepLinkType('chatroom');
        setDeepLinkData({ roomId, path });
      }
    }

    // Sezioni dirette
    else if (['/explore', '/feed', '/notifications', '/welcome'].includes(path)) {
      setDeepLinkType('section');
      setDeepLinkData({ section: path.slice(1), path });
    }

    // Log per debug
    if (path !== '/') {
      console.log('🔗 Deep link detected:', { path });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Funzione helper per costruire Universal Link completo
  const getUniversalLink = () => {
    return `https://app.wanderbuddy.com${location.pathname}${location.search}`;
  };

  // Funzione helper per costruire Custom Scheme
  const getCustomScheme = () => {
    if (deepLinkType === 'trip') {
      return `wanderbuddy://trip/${deepLinkData.tripId}`;
    }
    
    if (deepLinkType === 'sharedTrip') {
      return `wanderbuddy://share/trip/${deepLinkData.tripId}`;
    }
    
    if (deepLinkType === 'profile') {
      return `wanderbuddy://profile/${deepLinkData.nickname}`;
    }
    
    if (deepLinkType === 'appEvent') {
      return `wanderbuddy://app-event/${deepLinkData.eventId}`;
    }
    
    if (deepLinkType === 'chatroom') {
      return `wanderbuddy://chatroom/${deepLinkData.roomId}`;
    }
    
    if (deepLinkType === 'section') {
      return `wanderbuddy://${deepLinkData.section}`;
    }
    
    // Fallback
    return 'wanderbuddy://welcome';
  };

  return {
    deepLinkType,
    deepLinkData,
    getUniversalLink,
    getCustomScheme
  };
};
